import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadEmployeeAttendanceMonthWise = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.EMPLOYEE_ATTENDANCE_GET_MONTHLY_DETAIL_BY_EMPLOYEE_ID, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}



export const loadExitEmployeeStatus = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_EXIT_EMPLOYEE_RESIGNATION_STATUS, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

// job level list

export const loadJobLevelList = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.JOB_LEVEL_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading employee jo level list:", error);
        throw error;
    }
}